import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { ReagentsTypes } from "../../app/types/genericTables.types";

type UseReagentsType = {
  reagentsList: ReagentsTypes[];
  get: (id: ReagentsTypes["id"]) => ReagentsTypes | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useReagents = create<UseReagentsType>((set, get) => ({
  loading: false,
  reagentsList: [],
  query: "",
  setQuery: (query) => set({ query }),
  get: (id) => get().reagentsList.find((reagents) => reagents.id === id),
  fetchAll: async () => {
    set({ loading: true });
    try {
      const endpoint = "/generic/Reagents";
      const { data: response } = await getData(endpoint);
      set(() => ({
        reagentsList: response,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching analysisTypeList:", error);
      set({ loading: false });
    }
  },
}));
